export default {
  confirmDelete: 'Do you wish to delete "{0}"?',
  emptyMessage: 'No {0} available.',
  uploadButtonLabel: 'Upload {0}',
  files: 'files',
};
